import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import SelectDropdown from "../../components-react/SelectDropdown";
import {
  broadcast_variable,
  variable_types,
} from "../../common-data/DropdowData";
import { validateVariableForm } from "../Validations";

const VariableForm = ({
  isEdit,
  rowData,
  closeModal,
  userInfoData,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const initialFormValues = {
    variableName: isEdit && rowData?.variable_name ? rowData.variable_name : "",
    selectedVariableType:
      isEdit && rowData?.type
        ? variable_types.find((type) => type.value === rowData.type) ||
          rowData?.type
        : "",
    selectedVariableValue: isEdit && rowData?.value ? rowData.value : "",
    isActive: isEdit && rowData?.status === "active" ? true : false,
  };
  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState({});

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeDropdown = (name, value) => {
    if (name === "selectedVariableType") {
      setFormValues((prev) => ({
        ...prev,
        selectedVariableValue: "",
        [name]: value,
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit
      ? `/wati/broadcast/variable/${rowData?.uid}`
      : "/wati/broadcast/variable";
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(initialFormValues);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const errors = validateVariableForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const userData = {
        variable_name: formValues.variableName || "",
        type: formValues.selectedVariableType?.value || "",
        value: formValues.selectedVariableValue || "",
        status: formValues.isActive ? "active" : "inactive",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  };

  // console.log(formValues.selectedVariableValue);

  return (
    <>
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add"} Variable`}
        onClose={closeModal}
        btnTxt={isEdit ? "Update" : "Add"}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer" onSubmit={onSubmit}>
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="variableName" className="formInputLabel">
              Variable Name <span className="required">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Variable Name"
              className={`formInput ${
                formErrors.variableName ? "formError" : ""
              }`}
              name="variableName"
              value={formValues.variableName}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedVariableType" className="formInputLabel">
              Variable Type <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedVariableType ? "formError" : ""
              }`}>
              <SelectDropdown
                options={variable_types}
                selectedOption={formValues.selectedVariableType}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedVariableType", selectedValue)
                }
                name="type"
              />
            </div>

            {formValues.selectedVariableType?.value === "static" && (
              <span className="tiny-info-label">
                ⓘ Static Variables Will Be Placed As It Is!
              </span>
            )}
          </div>

          {formValues.selectedVariableType?.value === "static" && (
            <div className="formInputBox">
              <label htmlFor="selectedVariableValue" className="formInputLabel">
                Variable Value <span className="required">*</span>
              </label>

              <input
                type="text"
                placeholder="Enter Variable Value"
                className={`formInput ${
                  formErrors.selectedVariableValue ? "formError" : ""
                }`}
                name="selectedVariableValue"
                value={formValues.selectedVariableValue}
                onChange={onChangeInput}
              />
            </div>
          )}
        </div>

        {formValues.selectedVariableType?.value === "key" && (
          <div className="formInputsGrid twoGridSystem">
            <div className="formInputBox checkbox-wrapper span2">
              <label htmlFor="selectedVariableValue" className="formInputLabel">
                Choose Variable Value <span className="required">*</span>
              </label>

              <div className="flex-box">
                {broadcast_variable.map((field, index) => (
                  <label
                    className={`checkboxLabel ${
                      formErrors.selectedVariableValue ? "formError" : ""
                    }`}>
                    <input
                      key={index}
                      type="checkbox"
                      label={field.label}
                      name={`selectedVariableValue_${index}`}
                      checked={formValues.selectedVariableValue === field.value}
                      onChange={(e) => {
                        onChangeInput({
                          target: {
                            name: "selectedVariableValue",
                            value: e.target.checked ? field.value : "",
                          },
                        });
                      }}
                    />
                    {field.label}
                  </label>
                ))}
              </div>
            </div>
          </div>
        )}

        <div className="formInputsGrid switchInputs">
          <div className="formInputBox formInputSwitchBox flex-start">
            <div
              className={`commonWrapper commonSwitchWrapper no-border ${
                formErrors?.isActive ? "formError" : ""
              }`}>
              <Form.Check
                type="switch"
                name="isActive"
                label={`${formValues.isActive ? "Active" : "Not Active"}`}
                checked={formValues.isActive}
                onChange={onChangeInput}
              />
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default VariableForm;
